import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
interface GeneralTablesCellsCellRateSignature {
  Args: {
    rate: unknown;
    value: unknown;
  };
}

export default class GeneralTablesCellsCellRate extends Component<GeneralTablesCellsCellRateSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedRate() {
    // includeSign needs to be true
    return this.hotelAndMarketService.formatRate(this.rate, {
      includeSign: true,
    });
  }

  get rate(): number {
    // @ts-expect-error: Incorrect type
    return this.args.rate ?? this.args.value;
  }

  get rateClass(): string {
    if (this.rate < 0) {
      return 'parity-loss';
    }
    return 'parity-win';
  }

  <template>
    <span class={{this.rateClass}}>
      {{this.formattedRate}}
    </span>
  </template>
}
